import React from "react";
import { MapProvider, useMap } from "@webV2/map/MapProvider";
import { MapViewSvg } from "@webV2/map/MapView/MapViewSvg/MapViewSvg";
import { MapLoadingSpinner } from "@webV2/map/MapView/MapLoadingSpinner";
import { useAuthenticated, useFloors } from "@gettactic/hooks";

export interface MapViewEmbeddedProps {
  officeId: string;
  floorId: string;
  focussedResourceId?: string;
  date?: string;
  enableControls?: boolean;
  showMiniMap?: boolean;
}

const MapViewEmbeddedInner: React.FC<MapViewEmbeddedProps> = ({
  focussedResourceId,
  enableControls,
  showMiniMap = true
}) => {
  const { floor, isDataLoading } = useMap();

  if (isDataLoading || !floor?.id) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <MapLoadingSpinner />
      </div>
    );
  }

  return (
    <MapViewSvg
      embedded={true}
      allowFloorSwitcher={false}
      allowOverlays={enableControls}
      initialFocussedResource={focussedResourceId}
      allowInteractionsOnFocussedResource={true}
      showMiniMap={showMiniMap}
    />
  );
};

export const MapViewEmbedded: React.FC<MapViewEmbeddedProps> = (props) => {
  const { officeId, floorId } = props;
  const {
    userContext: { authenticatedUser }
  } = useAuthenticated();

  const office = props?.officeId ? authenticatedUser?.offices?.byId?.[officeId] : null;

  const { floors: allFloors } = useFloors(officeId, null);

  const floor = allFloors?.find((f) => f.id === floorId);

  if (!office || !floor) return "Loading...";

  return (
    <MapProvider
      officeId={officeId}
      initialFloorId={floorId}
      startDate={props.date}
      key={`${props.focussedResourceId}-${floorId}`}
      isEmbedded
      disableUrlOfficeSync={true}
    >
      <MapViewEmbeddedInner {...props} />
    </MapProvider>
  );
};
